// extracted by mini-css-extract-plugin
export var displayNone = "_up-6";
export var imgContainer = "_up-2";
export var overflowHidden = "_up-3";
export var productInfoCardButtonContainer = "_up-5";
export var productTitleText = "_up-4";
export var rightArrow = "_up-1";
export var rightArrowContainer = "_up-0";